import { IntersectionFade } from "../components/IntersectionFade";

function ProductMockup() {
  return (
    <div className="hero-mockup">
      <div className="hero-mockup-glow" aria-hidden="true" />
      <div className="hero-screen-wrap" role="img" aria-label="Kynetra Signage CMS dashboard mockup">
        {/* Title bar */}
        <div className="screen-topbar">
          <span className="screen-dot screen-dot-r" />
          <span className="screen-dot screen-dot-y" />
          <span className="screen-dot screen-dot-g" />
          <span className="screen-title">Kynetra CMS — Fleet Overview</span>
        </div>

        {/* Body */}
        <div className="screen-body">
          {/* Sidebar */}
          <div className="screen-sidebar" aria-hidden="true">
            <div className="screen-sidebar-item active" style={{ width: "90%", height: 22 }} />
            <div className="screen-sidebar-item" style={{ width: "80%", height: 22 }} />
            <div className="screen-sidebar-item" style={{ width: "85%", height: 22 }} />
            <div className="screen-sidebar-item" style={{ width: "75%", height: 22 }} />
            <div className="screen-sidebar-item" style={{ width: "80%", height: 22 }} />
            <div style={{ marginTop: 8, height: 1, background: "var(--border-subtle)" }} />
            <div className="screen-sidebar-item" style={{ width: "70%", height: 22, marginTop: 8 }} />
            <div className="screen-sidebar-item" style={{ width: "78%", height: 22 }} />
          </div>

          {/* Main area */}
          <div className="screen-main" aria-hidden="true">
            {/* Stat row */}
            <div className="screen-stat-row">
              <div className="screen-stat">
                <div className="screen-stat-val">48</div>
                <div className="screen-stat-lbl">Screens online</div>
              </div>
              <div className="screen-stat">
                <div className="screen-stat-val" style={{ color: "var(--success)" }}>100%</div>
                <div className="screen-stat-lbl">Cache hit rate</div>
              </div>
              <div className="screen-stat">
                <div className="screen-stat-val" style={{ color: "var(--accent-2)" }}>18ms</div>
                <div className="screen-stat-lbl">Avg sync latency</div>
              </div>
              <div className="screen-stat">
                <div className="screen-stat-val" style={{ color: "var(--warning)" }}>2,140</div>
                <div className="screen-stat-lbl">Plays today</div>
              </div>
            </div>

            {/* Canvas + device panel */}
            <div className="screen-canvas-row">
              <div className="screen-canvas">
                <div className="screen-canvas-zone-1">
                  <span className="screen-canvas-zone-1-text">Main zone · 16:9</span>
                </div>
                <div className="screen-canvas-zone-2">
                  <span className="screen-canvas-ticker">Now playing: summer-promo-v3.mp4</span>
                  <span className="screen-canvas-live">Live</span>
                </div>
              </div>
              <div className="screen-panel">
                {[
                  { name: "Lobby Display", status: "online" as const, label: "Web/PWA" },
                  { name: "Entrance TV",   status: "online" as const, label: "Android TV" },
                  { name: "Break Room",    status: "online" as const, label: "Raspberry Pi" },
                  { name: "Window Kiosk",  status: "offline" as const, label: "Electron" },
                  { name: "Boardroom 4K",  status: "online" as const, label: "Tauri" },
                ].map(({ name, status, label }) => (
                  <div key={name} className="screen-device-card">
                    <div className={`screen-device-dot ${status}`} />
                    <span className="screen-device-name">{name}</span>
                    <span className="screen-device-label">{label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function Hero() {
  return (
    <section className="hero" id="hero" aria-labelledby="hero-headline">
      {/* Background decorations */}
      <div className="hero-bg" aria-hidden="true">
        <div className="hero-orb hero-orb-1" />
        <div className="hero-orb hero-orb-2" />
        <div className="hero-orb hero-orb-3" />
        <div className="hero-grid-overlay" />
      </div>

      <div className="hero-content">
        {/* Badge */}
        <IntersectionFade delay={0}>
          <div className="hero-badge">
            <span className="hero-badge-dot" aria-hidden="true" />
            Phase 1 complete · Push sync · Offline-first · Free proof-of-play
          </div>
        </IntersectionFade>

        {/* Headline */}
        <IntersectionFade delay={60}>
          <h1 className="hero-headline" id="hero-headline">
            Digital signage,{" "}
            <span className="grad-text">engineered<br />for 2050.</span>
          </h1>
        </IntersectionFade>

        {/* Subhead */}
        <IntersectionFade delay={120}>
          <p className="hero-sub">
            One TypeScript engine. Every platform — Web, Electron, Tauri, Android TV, Raspberry Pi.
            WebSocket push-sync, content-addressed offline cache, and free proof-of-play analytics. Built on Cloudflare edge.
          </p>
        </IntersectionFade>

        {/* CTAs */}
        <IntersectionFade delay={180}>
          <div className="hero-ctas">
            <a href="#pricing" className="btn btn-primary btn-lg">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <polyline points="13 17 18 12 13 7" />
                <polyline points="6 17 11 12 6 7" />
              </svg>
              Get started free
            </a>
            <a href="#compare" className="btn btn-ghost btn-lg">
              See how it compares
            </a>
          </div>
        </IntersectionFade>

        {/* Mockup */}
        <IntersectionFade delay={260} direction="up">
          <ProductMockup />
        </IntersectionFade>
      </div>
    </section>
  );
}
